import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const UserService = {
  googleAuth: async () => {
    const response = await api.get(API_ENDPOINTS.USER.GOOGLEAUTH);
    return response;
  },

  googleAuthSignup: async (cid) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.GOOGLEAUTHSIGNUP, {
      cid,
    });
    const response = await api.post(endpoint);
    return response;
  },

  googleAuthCallback: async ({ code, state }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.GOOGLEAUTHCALLBACK, {
      code,
      state,
    });

    const response = await api.post(endpoint);
    return response;
  },

  verifyUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.VERIFY, userData);
    return response.data;
  },

  registerUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.REGISTER, userData);
    return response;
  },

  loginUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.LOGIN, userData);
    return response;
  },

  logoutUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.LOGOUT, userData);
    return response;
  },

  activateAccount: async (activateToken) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.ACTIVATE, {
      token: activateToken,
    });
    const response = await api.get(endpoint);
    return response;
  },

  sendOtp: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.SENDOTP, data);
    return response;
  },

  verifyOtp: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.VERIFYOTP, data);
    return response;
  },

  resendOtp: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.RESENDOTP, data);
    return response;
  },

  // Phone Login OTP methods
  sendPhoneLoginOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LOGIN_PHONE_SENDOTP,
      data
    );
    return response;
  },

  verifyPhoneLoginOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LOGIN_PHONE_VERIFYOTP,
      data
    );
    return response;
  },

  resendPhoneLoginOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LOGIN_PHONE_RESENDOTP,
      data
    );
    return response;
  },

  // Email Linking methods (for secondary auth)
  sendEmailLinkOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LINK_EMAIL_SENDOTP,
      data
    );
    return response;
  },

  verifyEmailLinkOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LINK_EMAIL_VERIFYOTP,
      data
    );
    return response;
  },

  resendEmailLinkOtp: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.LINK_EMAIL_RESENDOTP,
      data
    );
    return response;
  },

  submitEmailLink: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.LINK_EMAIL_SUBMIT, data);
    return response;
  },

  // Secondary auth: Google config fetch
  getGoogleSecondaryConfig: async () => {
    const response = await api.get(API_ENDPOINTS.USER.GOOGLE_SECONDARY_CONFIG);
    return response;
  },

  initiateGoogleSecondaryLink: async () => {
    // Using GET as per backend expectation to return auth_url JSON
    const response = await api.get(
      API_ENDPOINTS.USER.GOOGLE_SECONDARY_INITIATE,
      { withCredentials: true }
    );
    return response;
  },

  linkGoogleWithIdToken: async ({ idToken, state }) => {
    const response = await api.post(API_ENDPOINTS.USER.GOOGLE_SECONDARY_LINK, {
      id_token: idToken,
      state,
    });
    return response;
  },

  refreshToken: async (refreshTokenValue) => {
    const response = await api.post(API_ENDPOINTS.AUTH.REFRESH, {
      refresh_token: refreshTokenValue,
    });
    return response;
  },

  acknowledgeIntro: async () => {
    const response = await api.patch(API_ENDPOINTS.USER.ACKNOWLEDGE_INTRO);
    return response;
  },

  forgotPassword: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.FORGOTPASSWORD, data);
    return response;
  },

  resetPassword: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.RESETPASSWORD, data);
    return response;
  },

  changePassword: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CHANGEPASSWORD, data);
    return response;
  },
};
